(function () {
  /* ── Scroll reveals ── */
  function initOurStoryReveals(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.bbos-reveal');
    if (!nodes.length || typeof IntersectionObserver === 'undefined') return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.1 });
    nodes.forEach(function (node) { observer.observe(node); });
  }

  /* ── Photo carousel ── */
  function initCarousel(root) {
    var scope = root || document;
    var carousel = scope.querySelector('#bbos-carousel');
    if (!carousel) return;

    var track  = carousel.querySelector('#bbos-carousel-track');
    var stage  = carousel.querySelector('.bbos-carousel-stage');
    var slides = carousel.querySelectorAll('.bbos-carousel-slide');
    var dots   = carousel.querySelectorAll('.bbos-carousel-dot');
    var prev   = carousel.querySelector('.bbos-carousel-prev');
    var next   = carousel.querySelector('.bbos-carousel-next');

    if (!track || slides.length < 2) return;

    var current = 0;
    var total   = slides.length;

    function goTo(idx) {
      current = (idx + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Swipe support on the stage */
    var swipeTarget = stage || track;
    var startX = 0;
    swipeTarget.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    swipeTarget.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) goTo(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  function init(root) {
    initOurStoryReveals(root);
    initCarousel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
